import { p as proxyCustomElement, H, h, c as Host } from './p-92c4a1ea.js';
import './p-a57042e3.js';
import { a as ComponentUtils } from './p-de830ba7.js';
import { O as OnElementMutation } from './p-7b2053f2.js';
const componentFooterCss = ".sc-owc-component-footer-h{width:100%;min-height:var(--one-spacing-size-2-xl);padding:var(--one-spacing-padding-4-xs) var(--one-spacing-padding-2-xs);-webkit-box-sizing:border-box;box-sizing:border-box;background-color:var(--one-color-background-base);display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;position:relative;white-space:nowrap}.sc-owc-component-footer-h>.owc-component-footer__prefix-slot-wrapper.sc-owc-component-footer{justify-self:flex-start}.sc-owc-component-footer-h>.owc-component-footer__default-slot-wrapper.sc-owc-component-footer{-ms-flex-positive:1;flex-grow:1;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;font-family:var(--one-typography-font-family);font-size:var(--one-typography-desktop-subtitle-1-font-size);line-height:var(--one-typography-desktop-subtitle-1-line-height);-webkit-font-kerning:var(--one-typography-desktop-subtitle-1-font-kerning);font-kerning:var(--one-typography-desktop-subtitle-1-font-kerning);font-weight:var(--one-text-font-weight-regular)}.sc-owc-component-footer-h>.owc-component-footer__suffix-slot-wrapper.sc-owc-component-footer{justify-self:flex-end}.owc-component-footer--separator.sc-owc-component-footer-h{border-top:var(--one-spacing-outline-regular) solid var(--one-color-background-contrast)}.owc-component-footer--has-slot.sc-owc-component-footer-h>.owc-component-footer__default-slot-wrapper.sc-owc-component-footer{position:absolute;left:50%}@supports (translate: -50% 0){.owc-component-footer--has-slot.sc-owc-component-footer-h>.owc-component-footer__default-slot-wrapper.sc-owc-component-footer{translate:-50% 0}}@supports not (translate: -50% 0){.owc-component-footer--has-slot.sc-owc-component-footer-h>.owc-component-footer__default-slot-wrapper.sc-owc-component-footer{-webkit-transform:translate(-50%, 0);transform:translate(-50%, 0)}}@media screen and (min-width: 320px) and (max-width: 719px){.sc-owc-component-footer-h{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:var(--one-spacing-gap-s);padding:var(--one-spacing-padding-s) var(--one-spacing-padding-2-xs)}.owc-component-footer--has-slot.sc-owc-component-footer-h>.owc-component-footer__default-slot-wrapper.sc-owc-component-footer{position:relative;left:unset;-webkit-transform:unset;transform:unset}.owc-component-footer--has-slot.sc-owc-component-footer-h>.owc-component-footer__default-slot-wrapper.sc-owc-component-footer:empty{display:none}.sc-owc-component-footer-h>.owc-component-footer__suffix-slot-wrapper.sc-owc-component-footer [slot=suffix].sc-owc-component-footer{display:-ms-flexbox;display:flex;gap:var(--one-spacing-gap-s)}.sc-owc-component-footer-h>.owc-component-footer__suffix-slot-wrapper.sc-owc-component-footer:empty{display:none}}@media screen and (min-width: 0) and (max-width: 319px){.sc-owc-component-footer-h{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:var(--one-spacing-gap-s);padding:var(--one-spacing-padding-s) var(--one-spacing-padding-2-xs)}.owc-component-footer--has-slot.sc-owc-component-footer-h>.owc-component-footer__default-slot-wrapper.sc-owc-component-footer{position:relative;left:unset;-webkit-transform:unset;transform:unset}.owc-component-footer--has-slot.sc-owc-component-footer-h>.owc-component-footer__default-slot-wrapper.sc-owc-component-footer:empty{display:none}.sc-owc-component-footer-h>.owc-component-footer__suffix-slot-wrapper.sc-owc-component-footer [slot=suffix].sc-owc-component-footer{display:-ms-flexbox;display:flex;gap:var(--one-spacing-gap-s)}.sc-owc-component-footer-h>.owc-component-footer__suffix-slot-wrapper.sc-owc-component-footer:empty{display:none}}";
const OwcComponentFooterStyle0 = componentFooterCss;
var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const ComponentFooter = /*@__PURE__*/proxyCustomElement(class ComponentFooter extends H {
  constructor() {
    super();
    this.__registerHost();
    this.component = new ComponentUtils(this);
    this.separator = false;
    this.prefixWrapper = undefined;
    this.suffixWrapper = undefined;
    this.hasSlot = undefined;
  }
  onContentChange() {
    this.checkHasSlot();
  }
  checkHasSlot() {
    var _a, _b;
    this.hasSlot = !!((((_a = this.prefixWrapper) === null || _a === void 0 ? void 0 : _a.childElementCount) || 0) + (((_b = this.suffixWrapper) === null || _b === void 0 ? void 0 : _b.childElementCount) || 0));
  }
  render() {
    const hostClasses = this.component.getHostBemClasses({
      separator: this.separator,
      'has-slot': this.hasSlot
    });
    const prefixSlotWrapperClass = this.component.getChildBemClasses('prefix-slot-wrapper', hostClasses);
    const defaultSlotWrapperClass = this.component.getChildBemClasses('default-slot-wrapper', hostClasses);
    const suffixSlotWrapperClass = this.component.getChildBemClasses('suffix-slot-wrapper', hostClasses);
    return h(Host, {
      key: '637ef02aa65ea46f7b34ca7ee03ff96142c77299',
      class: hostClasses,
      slot: "footer"
    }, h("div", {
      key: 'e751ec818140c951c9944008e155c175f8bad36e',
      ref: el => this.prefixWrapper = el,
      class: prefixSlotWrapperClass
    }, h("slot", {
      key: 'f4babd9a2bfcc207a9651202fd86c3f04386a37c',
      name: "prefix"
    })), h("div", {
      key: '8defb3c337a3b726f712fb87df99acf90bd2dcef',
      class: defaultSlotWrapperClass
    }, h("slot", {
      key: '61a1976b7e67f0719a85f2392e2c1a557ebda84d'
    })), h("div", {
      key: '1ca1d20b0ad8840a03415e5f87016300af95a705',
      ref: el => this.suffixWrapper = el,
      class: suffixSlotWrapperClass
    }, h("slot", {
      key: 'b8209231dc5411aa235b0d99b0f18c094df507e6',
      name: "suffix"
    })));
  }
  get hostElement() {
    return this;
  }
  static get style() {
    return OwcComponentFooterStyle0;
  }
}, [6, "owc-component-footer", {
  "separator": [516],
  "prefixWrapper": [32],
  "suffixWrapper": [32],
  "hasSlot": [32]
}]);
__decorate([OnElementMutation({
  target: self => self.hostElement,
  attributes: true,
  childList: true,
  subtree: true
})], ComponentFooter.prototype, "onContentChange", null);
function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["owc-component-footer"];
  components.forEach(tagName => {
    switch (tagName) {
      case "owc-component-footer":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, ComponentFooter);
        }
        break;
    }
  });
}
export { ComponentFooter as C, defineCustomElement as d };